import React from 'react';
import SideMenu from '@v2/shared/Layouts/SideMenu';
import { accountMenu } from '@v2/shared/Layouts/Account/menu';
import { AccountLayoutProps } from '@v2/shared/lib/types';
import Full from '../Full';

/**
 * The shell the signed-in customer's pages share, in MagZoom's chrome — MagSpot's
 * counterpart, and TopMags' rail on both. See the note there.
 */
export default function Account({
  children,
  autoRenewServiceName,
  autoRenewUrl,
  activePath,
  ...fullProps
}: AccountLayoutProps) {
  return (
    <Full {...fullProps}>
      {/* No digital library: MagZoom does not sell digital editions either, and its
          legacy library page is blanked in domain-overrides. See accountMenu. */}
      <SideMenu
        label="Account"
        groups={accountMenu({ autoRenewServiceName, autoRenewUrl })}
        activePath={activePath}
      >
        {children}
      </SideMenu>
    </Full>
  );
}
